module.exports = __webpack_public_path__ + "img/sample-min-1.c0aa1d8b.png";